import React from 'react';
import { Container } from '@mui/material';
import Layout from '../../components/Layout';
import ManagerReportsSection from '../../components/manager/ManagerReportsSection';

const ManagerReports = () => (
  <Layout>
    <Container maxWidth="lg">
      <ManagerReportsSection />
    </Container>
  </Layout>
);

export default ManagerReports;
